import { Flex, Tabs, Input, Button, Form } from "antd";
import {
  UserOutlined,
  LockOutlined,
  EyeTwoTone,
  EyeInvisibleTwoTone,
} from "@ant-design/icons";
import Gradient from "@/assets/images/Gradient.png";

import TKDLogoWhite from "@/assets/icons/TKD-logo.svg?react";
import TKDLogoColor from "@/assets/icons/TKD-logo-color.svg?react";

import type { TabsProps } from "antd";
import { authMutationFactory } from "@/console/apis/auth/queryFactory";
import { useNavigate } from "react-router-dom";
import useAuth from "@/store/useAuth.ts";
import { useEffect, useState } from "react";
import ForgotPasswordModal from "../components/ForgotPasswordModal";

const items: TabsProps["items"] = [
  {
    key: "1",
    label: "Sign In",
  },
];
const generateDeviceId = () => {
  const existingDeviceId = localStorage.getItem("deviceId");

  if (existingDeviceId) {
    return existingDeviceId;
  }

  const newDeviceId = crypto.randomUUID();

  localStorage.setItem("deviceId", newDeviceId);

  return newDeviceId;
};

const Login = () => {
  const navigate = useNavigate();
  const { auth, setAuth } = useAuth();
  const { mutate: login } = authMutationFactory().login();
  const [form] = Form.useForm();
  const [isForgotPasswordVisible, setIsForgotPasswordVisible] = useState(false);
  const handleSubmit = (values: {
    email: string;
    password: string;
    device_id: string;
  }) => {
    login(
      {
        ...values,
        device_id: generateDeviceId(),
      },
      {
        onSuccess: (data) => {
          setAuth(data);
          localStorage.setItem("token", data.access_token);
          localStorage.setItem("refreshToken", data.refresh_token);
          navigate("/dashboard", {
            replace: true,
          });
        },
      }
    );
  };

  useEffect(() => {
    if (auth?.name) {
      navigate("/dashboard");
    }
  }, [auth, navigate]);

  return (
    <Flex justify="center" align="center">
      <Flex
        flex={1}
        justify="center"
        align="center"
        className="bg-no-repeat bg-cover hidden md:flex"
        style={{
          height: "100vh",
          backgroundImage: `url(${Gradient})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <TKDLogoWhite />
      </Flex>

      <Flex
        flex={1}
        vertical
        justify="center"
        align="center"
        className="w-full md:w-auto px-10 md:px-0 "
      >
        <TKDLogoColor />

        <Flex
          vertical
          justify="center"
          align="center"
          className="w-full md:w-[360px] "
        >
          <Tabs defaultActiveKey="1" items={items} className="self-start" />
          <Form form={form} onFinish={handleSubmit} className="w-full">
            <Form.Item name="email">
              <Input
                size="large"
                placeholder="username"
                className="rounded-[2px]"
                prefix={<UserOutlined className="text-[#2F54EB]" />}
                onChange={(e) => {
                  const value = e.target.value;
                  const englishOnly = value.replace(/[^A-Za-z0-9@._-]/g, "");

                  if (value !== englishOnly) {
                    e.target.value = englishOnly;
                    form.setFieldValue("email", englishOnly);
                  }
                }}
              />
            </Form.Item>
            <Form.Item name="password">
              <Input.Password
                size="large"
                type="password"
                placeholder="password"
                className="rounded-[2px]"
                prefix={<LockOutlined className="text-[#2F54EB]" />}
                iconRender={(visible) =>
                  visible ? <EyeTwoTone /> : <EyeInvisibleTwoTone />
                }
              />
            </Form.Item>

            <Flex justify="space-between" className="w-full">
              <a
                className="text-[#2F54EB]"
                // biome-ignore lint/a11y/useValidAnchor: <explanation>
                onClick={() => setIsForgotPasswordVisible(true)}
              >
                Forgot password?
              </a>
            </Flex>

            <Button
              size="large"
              type="primary"
              htmlType="submit"
              className="rounded-[2px] w-full mt-7"
            >
              Sign In
            </Button>
          </Form>
        </Flex>
      </Flex>
      <ForgotPasswordModal
        isVisible={isForgotPasswordVisible}
        onClose={() => setIsForgotPasswordVisible(false)}
      />
    </Flex>
  );
};

export default Login;
